import {useEffect} from "react";
import {useSignal} from "@preact/signals-react";
import {postSubmit} from "@ui-seeker/utils";

import {WEBBACK_V2_API} from "@constants";
import {useToast} from "@hooks";
import {isLoadingCommonFilters, retailer} from "@signals";
import { monitoringAdminReportFilters } from "../../@signals";


export default function useMonitoringAdminReportsDrawer() {

    const { showToast } = useToast()
    const reportFormFilters = useSignal({ ...monitoringAdminReportFilters.value })
    const isCreateMode = useSignal(false)

    const apiUrl = isCreateMode.value
        ? `${WEBBACK_V2_API}/monitoring/admin/create`
        : `${WEBBACK_V2_API}/monitoring/admin/update`

    const handleReportUpdate = () => {
        reportFormFilters.value = { ...reportFormFilters.value, sites: retailer.value }
        showToast.promise(postSubmit(apiUrl, reportFormFilters.value).then(res => {
            isLoadingCommonFilters.value = true
        }), {
            success: 'Execution updated successfully',
            error: 'There was an error updating the execution',
            loading: 'Updating...',
        })
    }

    useEffect(() => {
        reportFormFilters.value = {
            ...monitoringAdminReportFilters.value
        }
        retailer.value = reportFormFilters.value?.siteID || []
        isCreateMode.value = !!reportFormFilters.value?.createMode
    }, [monitoringAdminReportFilters.value])

    return {
        reportFormFilters: reportFormFilters,
        isCreateMode: isCreateMode.value,
        handleReportUpdate,
        DrawerTitle: isCreateMode.value ? 'Create Execution' : 'Edit Execution'
    }
}